/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { firstValueFrom } from 'rxjs';
import AppletError from '../../model/error';
import { getDatabase, PlatformDatabase } from '../database';
import { SessionManager, UserSession } from './user-session';

export default class UserSessionDb implements SessionManager {
  db: PlatformDatabase | undefined;

  init(): Promise<void> {
    if (this.db) {
      return Promise.resolve();
    }
    return firstValueFrom(getDatabase('smt-platform-requestor'))
      .then((db) => {
        this.db = db;
      })
      .catch((error) => {
        let appletError: AppletError = AppletError.createPlatformError({
          code: 401,
          status: 401,
          request_id: '',
          message: error?.message,
        });
        if (error instanceof AppletError) {
          appletError = error;
        }
        throw appletError;
      });
  }

  getSession(appId: string): Promise<UserSession | null> {
    if (!this.db) return Promise.reject(new Error('Call Init first'));
    return this.db.config
      .findOne(appId)
      .exec()
      .then((document) => document?.get('refreshToken') as string | undefined)
      .then((refresh) => ({ appId, refreshToken: refresh || null }));
  }

  setSession(session: UserSession): Promise<void> {
    if (!this.db) return Promise.reject(new Error('Call Init first'));
    return this.db.config
      .upsert({
        appId: session.appId,
        refreshToken: session.refreshToken ?? '',
      })
      .then(() => {});
  }
}
